import React from "react"
import { BadgeContainer } from "./Badge.styles"

export interface BadgeProps {
    text: string
    textColor: 'black' | 'white',
    backgroundColor: string,
}

export function Badge({ text, textColor, backgroundColor, ...rest }: BadgeProps) {

    return <BadgeContainer {...rest} textColor={textColor} backgroundColor={backgroundColor}>
        <span>{text}</span>
    </BadgeContainer>
}